import { Editor, Node, Path, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import { cloneNode } from '../duplicate';
import * as serializer from 'basic-editor-value-serializer';
const model = serializer.utilities.node.siteNav;

export function read(editor, path) {
  return model.readSettings(Node.get(editor, path));
}

export function write(editor, path, changes) {
  const node = Node.get(editor, path);
  const value = model.sanitizeSettings({ ...read(editor, path), ...changes });
  if (JSON.stringify(value) === JSON.stringify(node.properties.siteNav)) {
    return;
  }
  HistoryEditor.withNewBatch(editor, function saveHeader() {
    Transforms.setNodes(editor, { properties: { ...node.properties, siteNav: value } }, { at: path });
  });
}

export function replace(editor, path, node) {
  if (JSON.stringify(Node.get(editor, path)) === JSON.stringify(node)) {
    return;
  }
  HistoryEditor.withNewBatch(editor, function replaceContent() {
    Editor.withoutNormalizing(editor, function applyContent() {
      Transforms.removeNodes(editor, { at: path });
      Transforms.insertNodes(editor, node, { at: path });
    });
  });
}

export function add(editor, path, node) {
  HistoryEditor.withNewBatch(editor, function addContent() {
    const parent = Node.get(editor, path);
    let index = parent.children.length;
    Editor.withoutNormalizing(editor, function appendContent() {
      if (index === 1 && typeof parent.children[0].text === 'string') {
        Transforms.removeNodes(editor, { at: path.concat(0) });
        index = 0;
      }
      Transforms.insertNodes(editor, node, { at: path.concat(index) });
    });
  });
}

export function remove(editor, path) {
  HistoryEditor.withNewBatch(editor, function removeContent() {
    Transforms.removeNodes(editor, { at: path });
  });
}

export function move(editor, from, to) {
  HistoryEditor.withNewBatch(editor, function moveContent() {
    Editor.withoutNormalizing(editor, function moveHeaderContent() {
      Transforms.moveNodes(editor, { at: from, to });
    });
  });
}

export function duplicate(editor, node, path) {
  const copy = model.cloneNode(node, cloneNode);
  HistoryEditor.withNewBatch(editor, function duplicateHeader() {
    Transforms.insertNodes(editor, copy, { at: Path.next(path) });
  });
}
